import React, { useContext } from 'react';

import { getJobNameFromInvBillCrDbJobType, isHouseJob, isMasterJob } from "../../../../framework.core/JobNames";
import LinkButton from '../../../../ui/LinkButton';
import { AcctDetail } from '../../../../fms.core/AcctDetail';
import { NavigationType, openNewPage } from '../../../../util/navigationHelpers';
import { useHistory } from 'react-router';
import { ApplicableTableSettings, infoAreaBicTable } from '../../../../tableSettings';
import { DateRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer } from '../../../../uiControls/SmartTableRenderers';
import SmartTable from '../../../../uiControls/SmartTable';
import LastUpdateInfo from '../../../common/LastUpdateInfo';
import TextBox from '../../../../ui/TextBox';
import Date from '../../../../ui/Date';
import Label from '../../../../ui/Label';
import numeral from 'numeral';
import { getDecimal } from '../../../../util';
import { moveScreenToOperation, moveScreenToTop } from '../../../../features/screenStackSlice';
import useJobMenus from '../../../../hooks/useJobMenus';
import { useAppDispatch } from '../../../../app/hooks';
import constants from '../../../../constants';
import { moveJobToOperation } from '../../../../features/jobMenuSlice';
import { BtOrder } from '../../../../fms.core/BtOrder';
import { BillInvoiceSummaryTable, SalesCostSummary } from '../../../common/SalesCostEntry';
import ApplicationContext from '../../../../ApplicationContext';


function BTOrderBillingsDetails({
  commands,
  // billingInfo,
  btOrderInfo,
  summary,
}: {
  commands: React.ReactNode | string | null | undefined,
  // billingInfo: Array<AcctDetail>,
  btOrderInfo: BtOrder,
  summary: SalesCostSummary,
}) {
  // const history = useHistory();
  // const dispatch = useAppDispatch();
  const appContext = useContext(ApplicationContext);
  
  // const { getSingleOpenedScreenInAnyOperationStartingWithUrl } = useJobMenus();

  // function CurrencyRenderer(cellValue: any, currency: any, showZero: boolean = false) {
  //   let amount = '';
  //   const decimals = getDecimal(currency);
  //   if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
  //     const format = `0,0.${'0'.repeat(decimals)}`;
  //     amount = numeral(cellValue).format(format);
  //   }
  //   return (
  //     <div className="ifms-table-align-right">{parseFloat(amount) === 0 && !showZero ? null : amount}</div>
  //   );
  // }

  // function AccountingEntityRenderer(onLinkToAccounting: any, { data, row, value }: any) {
  //   const entity = data[row.index];

  //   return <div style={{ marginTop: '0px', marginLeft: '5px', textAlign: 'left' }}>
  //     <LinkButton onClick={() => onLinkToAccounting(entity)}>{value}</LinkButton>
  //   </div>;
  // }

  // function OnLinkToAccounting(entity: AcctDetail) {
  //   if (!entity || !entity.type || !entity.invoiceNo) {
  //     return;
  //   }

  //   let linkPath =  '';
  //   if (entity.type === 'B') {
  //     linkPath = `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(entity.jobType)}/${entity.jobId}/${entity.id}`
  //   }
  //   if (entity.type === 'I' ) {
  //     linkPath = `/accounting/invoice/view/${getJobNameFromInvBillCrDbJobType(entity.jobType)}/${entity.jobId}/${entity.id}`
  //   }

  //   if (linkPath) {
  //     const lastScreenQuery = getSingleOpenedScreenInAnyOperationStartingWithUrl(linkPath);
  //     if (lastScreenQuery && lastScreenQuery.item) {

  //       let destOp = constants.opTypes.order;
  //       dispatch(moveJobToOperation({
  //         sourceOperation: lastScreenQuery.operation,
  //         destinationOperation: destOp,
  //         url: linkPath,
  //       }));
  //       dispatch(moveScreenToOperation({
  //         sourceOperation: lastScreenQuery.operation,
  //         destinationOperation: destOp,
  //         url: linkPath,
  //       }));
  //       dispatch(moveScreenToTop({
  //         url: linkPath,
  //         operation: destOp,
  //       }));

  //       openNewPage(history, linkPath, NavigationType.jobMenuSwitch, lastScreenQuery?.item?.metadata, destOp??lastScreenQuery?.item?.afterScreenUrl);
  //       return;
  //     }

  //     openNewPage(history, linkPath, NavigationType.newPage);
  //   }
  // }

  // function acctTypeRenderer({ value }: any) {
  //   if (value === 'I') return <div className="ifms-table-default">Invoice</div>;
  //   else if (value === 'B') return <div className="ifms-table-default">Bill</div>;
  //   else return <span></span>;
  // }

  // function jobTypeRenderer({ value }: any) {
  //   let job = getJobNameFromInvBillCrDbJobType(value);
  //   if (isMasterJob(job)) return <div className="ifms-table-default">M</div>;
  //   else if (isHouseJob(job)) return <div className="ifms-table-default">H</div>;
  //   else return <span></span>;
  // }

  // const tableOptions: ApplicableTableSettings = {
  //   tableName: 'infoAreaBicTable',
  //   ...infoAreaBicTable,
  //   data: billingInfo.map(x => ({ ...x })),
  //   showNewRowPlaceholder: false,
  //   rowRenderers: [
  //     { accessor: 'postDate', Cell: DateRenderer },
  //     { accessor: 'type', Cell: acctTypeRenderer },
  //     { accessor: 'jobType', Cell: jobTypeRenderer },
  //     { accessor: 'draft', Cell: NullableCheckboxIconRenderer },
  //     // @ts-ignore:next-line
  //     { accessor: 'invoiceNo', Cell: AccountingEntityRenderer.bind(this, OnLinkToAccounting) },
  //     { accessor: 'entityName', Cell: TextAlignLeftRenderer },
  //     { accessor: 'cur', Cell: TextRenderer },
  //     // @ts-ignore:next-line
  //     { accessor: 'amount', Cell: ({ cell }) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur) },
  //     // @ts-ignore:next-line
  //     { accessor: 'paidAmount', Cell: ({ cell }) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur) },
  //     // @ts-ignore:next-line
  //     { accessor: 'balance', Header: () => <div style={{ marginRight: '8px' }}>Balance</div>, Cell: ({ cell }) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true) },
  //   ],
  // };



  return (
    <div className={`doc-details-v2 background-${appContext.backgroundColor}`}>
      <div className="doc-details-container-v2">
        <div className="oi-doc-title-row2">
          <div className="oi-doc-title2" style={{ width: '1000px' }}>
            <div style={{ width: '500px', display: 'flex', alignItems: 'center', marginLeft: '230px' }}>
              <Label style={{ fontSize: '14px' }} bold label={`PRO #: ${btOrderInfo.orderNo}`} />
              <div style={{ margin: 'auto' }}></div>
            </div>
          </div>
          <div style={{ marginLeft: 'auto' }} />

          <div className='doc-commands-wrapper'>
            {commands}
          </div>
        </div>

        <div id="hawb-details" style={{ width: '100%', overflowY: 'auto', height: 'calc(100vh - 100px)' }}>
          {/* <div className="doc-center-v2">
            <div>
              <div>
                <div style={{ display: 'flex', width: '100%' }}>
                  <div style={{ width: '210px', paddingLeft: '65px' }}>
                    <span>PRO #</span>
                    <TextBox disabled value={btOrderInfo.orderNo} />
                  </div>
                  <div style={{ width: '340px', paddingLeft: '110px' }}>  
                      <span>Customer</span>
                      <TextBox disabled value={btOrderInfo.billToName} />
                    <div style={{ paddingTop: '10px' }}>
                      <span>Shipper</span>
                      <TextBox disabled value={btOrderInfo.shipperName} />
                  </div>
                    <div style={{ paddingTop: '10px' }}>
                      <span>Pickup Location</span>
                      <TextBox disabled value={btOrderInfo.puLocName} />
                    </div>
                  </div>
                  <div style={{ width: '340px', paddingLeft: '110px' }}>
                    <span>Origin</span>
                    <TextBox disabled value={btOrderInfo.originName} />
                    <div style={{ paddingTop: '10px' }}>
                      <span>Destination</span>
                      <TextBox disabled value={btOrderInfo.destName} />
                    </div>
                  </div>
                  <div style={{ width: '180px', paddingLeft: '100px' }}>
                    <span>Departure</span>
                    <Date disabled value={btOrderInfo.departure} />
                    <div style={{ paddingTop: '10px' }}>
                      <span>Arrival</span>
                      <Date disabled value={btOrderInfo.arrival} />
                    </div>
                  </div>
                </div>

                <div style={{ paddingTop: '50px' }}>
                  <SmartTable {...tableOptions} />
                </div>

              </div>
            </div>
          </div> */}
          <div className="doc-center-v3">
            <Label bold label="● Bill" style={{ marginLeft:'20px', fontSize:'13px'  }} />
            <BillInvoiceSummaryTable summary={summary?.billSummary ?? []} isInvoice={false} height={'300px'} isNoLink hideCrdb />
            <Label bold label="● Invoice" style={{ marginLeft:'20px', fontSize:'13px', marginTop:'10px' }} />
            <BillInvoiceSummaryTable summary={summary?.invoiceSummary ?? []} isInvoice={true} height={'300px'} isNoLink hideCrdb />
          </div>
        </div>
      </div>
      <LastUpdateInfo updateBy={btOrderInfo.u2Id} updateDate={btOrderInfo.u2Date} />
    </div>
  );
}

export default React.memo(BTOrderBillingsDetails);
